<template>
  <div v-element-sizes="{ id: 'window' }" class="layout-default">
    <!-- <WidgetMouseCursor /> -->
    <SeoTemplatePreset>
      <NavigationMenu />
      <main>
        <slot />
      </main>

      <FooterMain />

      <WidgetFloatingBook v-if="false && !hidePrenotaCta" />
      <ListingProjectBlockFullscreenOverlay />
      <WidgetFullScreenVideoOverlay />
    </SeoTemplatePreset>
  </div>
</template>

<script setup>
import { printOutCompany } from '@/assets/js/misc.js'

const route = useRoute()
const fromError = setFromError()

const hidePrenotaCta = computed(() => {
  const excludedRoutes = [
    '/contacts',
    '/contatti',
  ]
  return excludedRoutes.find((routeString) => route.path.includes(routeString))
})

onMounted(() => {
  printOutCompany()
})
</script>
